"use strict";

exports.__esModule = true;
exports.ActivitiesClient = void 0;
var _http = require("@tajawal/web-core-sdk-v2/lib/services/http.service");
var _constants = require("../constants");
const ActivitiesClient = {
  /**
   * @description Return the orders of a customer
   * @returns {Promise}
   */
  async fetch({
    data
  }) {
    const requestId = 'FETCH_HAS_ACTIVITY';
    const endPoint = _constants.ENDPOINTS.GET_HAS_EXPLORE_ACTIVITY;
    return _http.$http.post(requestId, endPoint, {
      data
    }).then(({
      data
    }) => data);
  }
};
exports.ActivitiesClient = ActivitiesClient;